export default __webpack_public_path__ + "static/media/node.cedef792.svg";